<div class="container">
  <div class="row mt-4">
    <div class="col-lg-6">

        <label class="header-text">See all the ways you save.</label>
      <span *ngIf="!showIfPurchaseIsNotAdha">
        <label class="sub-text">
          Discount fees vary by state. <br>
          Select your state:
        </label>

        <select name="state" id="state" class="form-control mt-3" (change)="stateChanged($event)" [ngModel]="stateAbbr">
          <option value="none">SELECT STATE</option>
          <option value="{{state.abbr}}" *ngFor="let state of em.allowedStates">{{state.name}}</option>
        </select>
      </span>
    </div>
    <div class="col-lg-6 d-flex justify-content-center">
      <img class="map" src="{{mapImagePath}}" alt="">
    </div>

  </div>
  <div class="row">
    <div class="col-12" style="height: 50px;"></div>
  </div>
  <div class="row mt-4 mb-5">
    <div class="col-lg-6">
      <label class="summary-link" (click)="openUrl('fees')" *ngIf="stateChosen"><img src="assets/images/Group%20527.png" alt=""> Your state's most commonly viewed fees <img src="assets/images/down.png" alt=""></label> <br>
      <label class="summary-link" (click)="openUrl('discount')" *ngIf="stateChosen"><img src="assets/images/Group%20527.png" alt=""> Your state's full fee schedule <img src="assets/images/down.png" alt=""></label>
    </div>
    <div class="col-lg-6">
      <span class="text-sm-roboto float-lg-end text-lg-end" style="width: 75%;">Smile Generation Dental Plan® is currently accepted at Smile Generation®-trusted offices in 24 states.</span>
    </div>
  </div>
</div>
